import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { CloseButton, Fade } from '../components/common/Toast';

//import DashboardLayout from './DashboardLayout';
import ErrorLayout from './ErrorLayout';

import loadable from '@loadable/component';
const AuthBasicLayout = loadable(() => import('./AuthBasicLayout'));
const Landing = loadable(() => import('../components/landing/Landing'));
const WizardLayout = loadable(() => import('../components/auth/wizard/WizardLayout'));
const AuthCardRoutes = loadable(() => import('../components/auth/card/AuthCardRoutes'));
const AuthSplitRoutes = loadable(() => import('../components/auth/split/AuthSplitRoutes'));
const technicalLanding = loadable(() => import('../components/technicalDetails/TechnicalLanding'));
const aboutLanding = loadable(() => import('../components/aboutTeam/AboutLanding'));
const supportersLanding = loadable(() => import('../components/supporters/SupportersLanding'));
const SL2026Landing = loadable(() => import('../components/sl2026/SL2026Landing'));
const ContactLanding = loadable(() => import('../components/contact/ContactLanding'));

const Layout = () => {
  useEffect(() => {
    AuthBasicLayout.preload();
    Landing.preload();
    WizardLayout.preload();
    AuthCardRoutes.preload();
    AuthSplitRoutes.preload();
  }, []);

  return (
    <Router fallback={<span />}>
      <Switch>
        <Route path="/landing" exact component={Landing} />
        <Route path="/authentication/basic" component={AuthBasicLayout} />
        <Route path="/authentication/card" component={AuthCardRoutes} />
        <Route path="/authentication/split" component={AuthSplitRoutes} />
        <Route path="/authentication/wizard" component={WizardLayout} />
        <Route path="/technical" component={technicalLanding} />
        <Route path="/about" component={aboutLanding} />
        <Route path="/supporters" component={supportersLanding} />
        <Route path="/kontakt" exact component={ContactLanding} />
        <Route path="/errors" component={ErrorLayout} />
        <Route path="/sl2026" exact component={SL2026Landing} />
        <Route path="/sl26" exact component={SL2026Landing} />
        <Route component={Landing} />
      </Switch>
      <ToastContainer transition={Fade} closeButton={<CloseButton />} position={toast.POSITION.BOTTOM_LEFT} />
    </Router>
  );
};

export default Layout;
